import type { ReactNode } from 'react'
import { modals } from '@mantine/modals'
import { Text } from '@mantine/core'
import type { TranslateFunction } from '@front/model'
import { MaterialSymbolIcon } from '@components'
type Props = {
  title: string
  message: ReactNode
  label?: string
  t: TranslateFunction
}

export const confirmDelete = ({ title, message, label, t }: Props): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    modals.openConfirmModal({
      title,
      children: typeof message === 'string' ? <Text>{message}</Text> : message,
      labels: {
        confirm: label ?? t('Delete'),
        cancel: t('Cancel'),
      },
      confirmProps: {
        color: 'red',
        leftSection: <MaterialSymbolIcon icon='delete' size={14} />,
      },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    })
  })
}

export const confirmActionModal = ({ title, message, label, t }: Props): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    modals.openConfirmModal({
      title,
      children: typeof message === 'string' ? <Text>{message}</Text> : message,
      labels: {
        confirm: label ?? t('Confirm'),
        cancel: t('Cancel'),
      },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    })
  })
}
